<template>
  <div :class="computedClasses">
    <HpIcon
      name="checkmark-animate"
      class="rounded-full bg-success p-3 text-white"
      :class="size === 'small' ? 'size-12' : 'size-16'"
    />
  </div>
</template>

<script lang="ts" setup>
  export type SizeVariant = 'small' | 'large'

  const props = defineProps({
    size: {
      type: String as PropType<SizeVariant>,
      default: 'large'
    }
  })

  const computedClasses = computed(() => ['success-check', props.size])
</script>

<style scoped>
  .success-check {
    @apply mx-auto scale-0;
    animation: pop-in 200ms cubic-bezier(0.165, 0.84, 0.44, 1) 150ms forwards;
  }

  .success-check.large {
    @apply min-h-16;
  }

  .success-check.small {
    @apply min-h-12;
  }

  @keyframes pop-in {
    100% {
      @apply scale-100;
    }
  }

  :deep(svg) {
    fill: none;
    stroke: #ffffff;
    stroke-width: 8;
    stroke-linejoin: round;
    stroke-dasharray: 87;
    stroke-dashoffset: 87;
    animation: draw 500ms cubic-bezier(0.785, 0.135, 0.15, 0.86) 450ms forwards;
  }

  @keyframes draw {
    to {
      stroke-dashoffset: 0;
    }
  }
</style>
